import { FALLBACK_PRECISION } from '@/helpers/unit-formatter/shared/constants';
import {
  DynamicLabelFormatterInput,
  FormattedUnitLabels,
} from '@/helpers/unit-formatter/shared/types';
import {
  formatNumber,
  formatTwoNonZeroDecimals,
  unitValueToFormattedUnitLabels,
} from '@/helpers/unit-formatter/shared/utils';

/**
 * Fallback formatter for values whose display units have no catalog entry.
 * |x| > 1 rounds to FALLBACK_PRECISION decimals; |x| ≤ 1 keeps two leading
 * non-zero decimal digits as a string (no scientific notation).
 */
export const formatNumberDefault = ({
  value,
  unitLabel,
}: DynamicLabelFormatterInput): FormattedUnitLabels => {
  const formattedValue =
    Math.abs(value) > 1 ? formatNumber(value, FALLBACK_PRECISION) : formatTwoNonZeroDecimals(value);

  return unitValueToFormattedUnitLabels({ value: formattedValue, units: unitLabel });
};
